import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/www/app/[locale]/contact-sales/components/close-button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/www/app/[locale]/contact-sales/components/form/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/app/[locale]/contact-sales/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["ConsentManager"] */ "/vercel/path0/apps/www/components/materia/consent-manager/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-datocms/dist/esm/Image/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-datocms/dist/esm/useQuerySubscription/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-datocms/dist/esm/useSiteSearch/index.js");
